module.exports = __webpack_public_path__ + "static/img/empty-kit.3e968a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty-kit.svg
// module id = 434
// module chunks = 0